<template>
  <div class="page box">
    <div  >
  <!-- <van-tabs class="activetabs" v-model:active="active" @change="activeTabs" animated shrink v-if="childInfoList.length>0">
  <van-tab v-for="(childItem,childindex) in childInfoList" :title="childItem.studentName" :key="childindex">

   

  </van-tab>
</van-tabs>   -->
<van-sticky class="sticky">
<div>
</div>
</van-sticky>
      <div class="center">
      <van-row gutter="20">
     
      <van-col span="17" class="text_l">
        <div style="display:flex;align-items: center;height:8vh;">
          <div class="center_name">{{homeworkByHomeInfo.homeName}}</div>
          <div>
          <van-tag plain  type="success">{{['已结束','进行中'][+homeworkByHomeInfo.status]}}</van-tag>
          </div>
        </div>
        <div style="margin-bottom:10px;">
          <span style="color: rgba(0, 0, 0, 0.4);">时间</span>
           {{homeworkByHomeInfo.startDate||''}} ~ {{homeworkByHomeInfo.endDate||''}}</div>
      
      </van-col>
       <van-col span="7" class="text_l"  style="display:flex;align-items: center;height:8vh;">
         <van-button type="info" :disabled='+homeworkByHomeInfo.status!==1' style="border-radius: 10px;margin-top:10px;width:85%" size="mini" @click="onhomeworkSubmit(homeworkByHomeInfo)">作业提交</van-button>
      </van-col>
    </van-row>

    <div  style="margin-top:10px;">

        <div >
            <div v-for="(itemc,ic) in homeworkByHomeInfo.homeworkProjectList"  :key='ic'  class="project_li">
            <div > <span style="font-size:3.3vw;font-weight: bold">{{itemc.projectName}}:</span> {{itemc.remark}}</div>
              <img src="@/assets/image/已测.png" alt="" width="100%" v-if="!!+itemc.isHaveScore" class="isHaveScore">
            </div>
        </div>

        <div class="project_ul" style="margin-top:10px;">
          <!-- homeworkByHomeInfo.homeworkWeekList -->
            <div v-for="(itemc,ic) in homeworkByHomeInfo.homeworkWeekList"  :key='ic'  class="Week_li">
            <div > {{weekFil[itemc.week]}}、 </div>
              <img src="@/assets/image/已测.png" alt="" width="100%" v-if="!!+itemc.isHaveScore" class="isHaveScore">
            </div>
        </div>
        
        <!-- <div class="project_baogao"  @click="onReport(homeworkByHomeInfo)"> 体测报告 <van-icon name="arrow" /></div> -->
    </div>
    <!-- <van-cell style="text-align: center;" title="体测报告" is-link  @click="onReport(homeworkByHomeInfo)"/> -->

    </div>
  <van-tabs v-model="fractionStatus" style="margin:10px;" @change="fractionStatusChange" >
    <van-tab title="已评分" name='1'></van-tab>
    <van-tab title="未评分" name='0'></van-tab>
  </van-tabs>
  <div>
    
    <div v-if="homeWorkStatusList.length>0">
        <div v-for="(item,index) in homeWorkStatusList" :key='index' class="center"> 
        <van-row>
          <van-col span="12"><van-rate v-model="item.evaluateFraction" readonly color="#ffd21e"
  void-icon="star"
  void-color="#eee"/></van-col>
          <van-col span="12" style="text-align: right;">
            <div v-show="+fractionStatus==0">{{item.submitTime||''}}</div>
            <div v-show="+fractionStatus==1">{{item.evaluateDate||''}}</div>
          </van-col>
        </van-row>
          <!-- evaluateFraction -->
          <div class="centervideobox">
          <div v-for="(itemc,indexc) in item.homeworkMediaResourceList" :key='indexc' class="videoLibox">
              <VideoDialog :url='itemc.resourcePath'>
                <template slot="icon">
                <div  class="dfcenter">
                <img src="@/assets/image/播放.png"  alt="" style="width: 60%; height: 60%;margin:10%;">
                </div>
                </template>
              </VideoDialog>
          </div>
          </div>
          <div>家长留言：{{item.remark||''}}</div>
          <div>老师留言：{{item.teacherRemark||''}}</div>
          
           
        </div>
    </div>

        <div v-else>
          <van-empty description="暂无数据" />
        </div>
  </div>


    </div>
   <van-popup v-model="submitShowPicker"  position="bottom" :style="{ height: '100%' }">
  <van-field name="file"   label="视频" placeholder="请上传视频" style="margin-top:15px;">
        <template #input>
      <PublicUpLoader v-model ="file" @change="changeUpLoader" :item='upLoaderItem'/>
        </template>
      </van-field>
     <van-field
    v-model="formData.remark"
    rows="3"
    autosize
    label="家长留言"
    type="textarea"
    placeholder="请输入留言"
  />
    <div class="buutom">
      <CustomButton  class="button-on" text="返回" @click="submitShowPicker=false" type='2'/>
      <CustomButton  class="button-on" text="确认" @click="onSubmitForm" type='1'/>
        </div>
    </van-popup>

  </div>

</template>

<script>
import CustomButton from "@/components/CustomButton.vue";
import { getChildInfoList} from "@/api/studentBind.js";
import { checkOrder,getHomeworkInfoList,getHomeworkByHomeId,getFractionByFractionStatus,submitHomework} from "@/api/homework.js";
// import studentTitleCard from "@/components/studentTitleCard.vue";
 import { setSession ,getSession} from "@/utils/cookie";
import PublicUpLoader from "@/components/PublicUpLoader.vue";
import VideoDialog from "@/components/VideoDialog.vue";

import store from '@/store'
export default {
data () {
    return {
        childInfoList:[],
        studentInfo:{},
        active:'0',
        yearList:[],
        onStudentInfo:{},
        weekFil:['','周一','周二','周三','周四','周五','周六','周日'],
        homeworkByHomeInfo:{},
        fractionStatus:1,
        submitShowPicker:false,
        formData:{},
        file:[],
        upLoaderItem:{
        type: 'Uploader',
        label: '视频',
        accept: 'video/*',
        disabled: false,
        icon: require('@/assets/appeal/video-icon.png'),
        max: 3,
        upType: 'video', //类型
        name: 'file',
        upName: '添加视频', //自定义名称
        rules: [{ required: true, message: '请添加视频' }],
        },
        homeWorkStatusList:[]
    }
},
components: {
  CustomButton ,
  PublicUpLoader,
  VideoDialog
  // studentTitleCard
},
mounted () {
    this.init()
},
methods:{
  onSubmitForm(){
    
    console.log(this.file);
     this.$dialog
        .alert({
          message: '是否确认提交?',
          showCancelButton: true
        })
        .then(() => {
            let data
            data = new FormData();
            data.append("snCode", this.$route.query.snCode)
            data.append("remark", this.formData.remark)
            data.append("homeId", this.$route.query.homeId)
            for (let index = 0; index < this.file.length; index++) {
              const element = this.file[index];
              data.append("homeworkFile", element?.file||'')
            }

            submitHomework(data).then(Res=>{
            this.$notify({ type: "success", message: '提交成功！' });
            this.init()
            this.submitShowPicker =false
            })
        })
  },
  changeUpLoader(val){

  },
  fractionStatusChange(){
    console.log(this.fractionStatus);
    this.getFractionByFractionStatus()
  },
  onhomeworkSubmit(){
    this.submitShowPicker = true
  },
  studentChange(val){
  // this.onStudentInfo =val
  // this.getHomeworkInfoList()
//   this.checkOrder()
  },
  onReport(item){
      let data = JSON.stringify({...this.onStudentInfo,
           termName: item.name,
      termCode:item.code,
      })
        this.$router.push({path:'fitnessReport',query:{data:data}})
  },
    onAddAppoint(){
       let data = {
            snCode:this.onStudentInfo.snCode,
            schoolCode:this.onStudentInfo.schoolCode,
          }
        this.$router.push({path:'addTest',query:data})
    },
     activeTabs(){
         this.getHomeworkInfoList()
         this.checkOrder()
    },
    init(){
        //   getChildInfoList({status:'1'}).then(res=>{
        // console.log(res);
        // this.childInfoList = res.data.data||[]
        // })
        getHomeworkByHomeId({homeId:this.$route.query.homeId,snCode:this.$route.query.snCode}).then(res=>{
          console.log(res.data.body);
          this.homeworkByHomeInfo = res.data.body||{}
        })
    this.getFractionByFractionStatus()
    },
    getFractionByFractionStatus(){
      getFractionByFractionStatus({fractionStatus:this.fractionStatus,homeId:this.$route.query.homeId,snCode:this.$route.query.snCode}).then(res=>{
        console.log(1, res.data.data);
        this.homeWorkStatusList = res.data.data||[]
        console.log(2,this.homeWorkStatusList);
      })
    },
    checkOrder(){
        checkOrder({
            snCode:this.onStudentInfo.snCode,
            schoolCode:this.onStudentInfo.schoolCode,
          }).then(res=>{
            // 检查是否有准考证
            console.log(res);
            if (!+res.data.body) {
                // 没有准考证
                this.$dialog
                .alert({
                message: '请先申请电子准考证！！',
                showCancelButton: false
                }).then(() => {
                    this.$router.push({path:'admissionTicket'})
                })
        
            }   
            // res.body
          })
    },
    getHomeworkInfoList(){
        getHomeworkInfoList({
            snCode:this.onStudentInfo.snCode,
            schoolCode:this.onStudentInfo.schoolCode,
          }).then(res=>{
            res.data.data?.forEach(el => {
              el?.studentProjectList?.forEach(dl=>{
                if (dl.projectCode=='HeightWeight') {
                  dl.projectName = 'BMI'
                }
              })
            });
            this.yearList = res.data.data
          })
    },
    OnaddFaceIn(){
        if (!this.studentInfo.faceData||this.studentInfo.faceData=='') {
            this.$notify({ type: "danger", message: '请拍摄证件照！' });
            return
        }
        this.$dialog
        .alert({
          message: '是否确认生成准考证?',
          showCancelButton: true
        })
        .then(() => {
            insertIntoFaceData(this.studentInfo).then(Res=>{
            this.$notify({ type: "success", message: '生成成功！' });
            this.$router.back(-1)
            })
        })
        .catch(() => {
          // on cancel
        })
    },
    
}
}
</script>

<style lang="less" scoped>
.box{
    padding: 5px;
    font-size: 3vw;
}
.text_l{
    text-align: left;
    text-overflow:ellipsis;
    overflow:hidden;
    // white-space:nowrap;
    
}
.noActiceCard{
    position: relative;
 .ifActiveBox{
          position: absolute;
          right: 0px;
          top: 10px;
          transform: rotate(45deg);
        }
}
.buutom {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  .button-on{
    width: 48%;
}
}
.Week_li{
   position: relative;
    width: 12%;
    height: 30px;
    margin-right: 1%;
    line-height: 30px;
    border-radius: 9px;
    font-size: 3vw;
    margin-bottom: 10px;

}
.project_title{
  font-size: 3.8vw;
  text-align: left;
  margin-bottom: 10px;
}
.project_ul{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

 .isHaveScore{
      position: absolute;
      top: 0;
      right: 0;
      width: 20%;
    }

 .tag_span_green{
                border: 1px solid rgb(61, 224, 61);
    border-radius: 8px;
                color: #37cf18;
                text-align: center;
                width: 90%;
                overflow: hidden;
            }
            .tag_span_grey{
                border: 1px solid rgb(141, 135, 135);
    border-radius: 8px;
                color: #6a6d69;
                text-align: center;
                width: 90%;
                overflow: hidden;
            }
}
  .project_li{
    position: relative;
    // height: 33px;
    margin-right: 3%;
    // line-height: 33px;
    border-radius: 9px;
    font-size: 3vw;
    margin-bottom: 10px;
    text-align: left;
    overflow: hidden;
    // 三点省略;
   
}
.project_baogao{
  text-align: center;
  font-size: 3.5vw;
  margin: 10px 0;
  color: #3c69e6;

}
 .center{
        // height: 250px;
        padding:12px;
        position: relative;
        background-color: #fff;
        border-radius: 10px;
        // border: 1px solid #ccc;
        margin: 8px;
        box-shadow: 2px 2px 3px 3px rgba(226, 225, 225, 0.6);
        text-align: left;
        .centervideobox{
          display: flex;
        }
        .videoLibox{width: 30%;}
    

    

    
    }
   
</style>